/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { matrixDependencies } from './dependenciesMatrix.generated';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createKron } from '../../factoriesAny.js';
export var kronDependencies = {
  matrixDependencies: matrixDependencies,
  multiplyScalarDependencies: multiplyScalarDependencies,
  typedDependencies: typedDependencies,
  createKron: createKron
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesKron.generated.js
// module id = 1572
// module chunks = 0